<template>
  <div class="form-overview">
    <p><strong>Formularz:</strong> {{ form.formName }}</p>
    <p><strong>Projekt:</strong> {{ form.projectName }}</p>
    <p><strong>Strona podziękowań:</strong> {{ form.thankYouPageUrl }}</p>
    <p>
      <strong>Pola:</strong>
      <span v-bind:key="fieldName" v-for="(input, fieldName) in form.inputs">
        <b-badge class="rounded-pill" variant="success">{{ input.name }}</b-badge>&nbsp;
      </span>
    </p>
    <p>
      <strong>Powiadomienia e-mail:</strong>
      <ul v-if="form.notifications.email.length > 0">
        <li v-bind:key="notification.id" v-for="notification in form.notifications.email">
          <b>{{ notification.recipients.direct.join(', ') }}</b> - {{ notification.messageTemplate.title }} <span class="text-gray-500">({{ notification.status === 'ACTIVE' ? 'aktywne' : 'zatrzymane' }})</span>
        </li>
      </ul>
      <span v-else><i>--Brak powiadomień--</i></span>
    </p>
    <p>
      <strong>Powiadomienia SMS:</strong>
      <ul v-if="form.notifications.sms.length > 0">
        <li :key="notification.id" v-for="notification in form.notifications.sms">
          <b>{{ notification.recipient }}</b> <span class="text-gray-500">({{ notification.status === 'ACTIVE' ? 'aktywne' : 'zatrzymane' }})</span>
        </li>
      </ul>
      <span v-else><i>-- Brak powiadomień --</i></span>
    </p>
    <p>
      <strong>Webhooki:</strong>
      <ul v-if="form.webhooks.length > 0">
        <li :key="webhook.id" v-for="webhook in form.webhooks">
          <b>{{ webhook.description !== '' ? webhook.description : webhook.address }}</b> <span class="text-gray-500">({{ webhook.status === 'ACTIVE' ? 'aktywne' : 'zatrzymane' }})</span>
        </li>
      </ul>
      <span v-else><i>-- Brak webhooków --</i></span>
    </p>
  </div>
</template>
<script>

import formHelper from './formHelper'

export default {
  props: ['form'],
  data () {
    return {}
  },
  name: 'c-form-full-overview',
  methods: {
    ruleText (rule) {
      return formHelper.ruleText(rule)
    }
  }
}
</script>
